import { BULK_SPLIT_SHIP } from '@customink/project-service-react-components';
import Big from 'big.js';

const { SHIPPING_FEE } = BULK_SPLIT_SHIP;

export const DEFAULT_PRICE = '0.00';

export const totalIndividualShippingFee = (addressCount: number): string => {
  return Big(SHIPPING_FEE).times(addressCount).toFixed(2);
};

// alternative to lodash groupBy because Object.groupBy has limited support
export function groupBy<K, V>(list: Array<V>, keyGetter: (input: V) => K) {
  const map = new Map<K, Array<V>>();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
}
